// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton--closeButton--1iOhW","closeButton__icon":"CloseButton--closeButton__icon--16CxN"};